import { __assign, __awaiter, __extends, __generator } from "tslib";
import { DeleteItemCommand as __DeleteItemCommand } from "@aws-sdk/client-dynamodb";
import { Command as $Command } from "@aws-sdk/smithy-client";
import { marshallInput, unmarshallOutput } from "../commands/utils";

var DeleteCommand = function (_super) {
  __extends(DeleteCommand, _super);

  function DeleteCommand(input) {
    var _this = _super.call(this) || this;

    _this.input = input;
    _this.inputKeyNodes = [{
      key: "Key"
    }, {
      key: "Expected",
      children: {
        children: [{
          key: "Value"
        }, {
          key: "AttributeValueList"
        }]
      }
    }, {
      key: "ExpressionAttributeValues"
    }];
    _this.outputKeyNodes = [{
      key: "Attributes"
    }, {
      key: "ItemCollectionMetrics",
      children: [{
        key: "ItemCollectionKey"
      }]
    }];
    return _this;
  }

  DeleteCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
    var _this = this;

    var _a = configuration.translateConfig || {},
        marshallOptions = _a.marshallOptions,
        unmarshallOptions = _a.unmarshallOptions;

    var command = new __DeleteItemCommand(marshallInput(this.input, this.inputKeyNodes, marshallOptions));
    var handler = command.resolveMiddleware(clientStack, configuration, options);
    return function () {
      return __awaiter(_this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, handler(command)];

            case 1:
              data = _a.sent();
              return [2, __assign(__assign({}, data), {
                output: unmarshallOutput(data.output, this.outputKeyNodes, unmarshallOptions)
              })];
          }
        });
      });
    };
  };

  return DeleteCommand;
}($Command);

export { DeleteCommand };